import gql from 'graphql-tag';
const VOWEL_COMBO_LAUNCH_ACTIVITY_FRAGMENT = gql `
  fragment VowelComboLaunchActivityFragment on VowelComboLaunchActivity {
    rounds {
      roundIndex
      steps {
        stepIndex
        answer
        isLeft
        prefix
        suffix
      }
    }
  }
`;
export default VOWEL_COMBO_LAUNCH_ACTIVITY_FRAGMENT;
